import { FC } from "react";
import { LoaderFunctionArgs, Outlet, redirect } from "react-router";
import { core, coreConfig } from "..";

export const configurationScreenLoader = async (args: LoaderFunctionArgs) => {
  await core
    .recover(coreConfig)
    .catch((e) => {
      console.error(e);
      throw redirect("/auth");
    });
  if (!core.user) throw redirect("/auth");

  return null;
};
export const ConfigurationScreen: FC = () => {
  return <Outlet />;
};
